import React, { useRef } from "react";
import { useDrop } from "react-dnd";
import { NativeTypes } from "react-dnd-html5-backend";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import PropTypes from "prop-types";

const AngDropFiles = ({ className, onDrop, context, single }) => {
  const dropRef = useRef(null);
  const [{ canDrop }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item) {
        const files = item.files;
        if (single && files.length > 1) {
          return;
        }
        typeof onDrop === "function" && onDrop(files);
        if (context && context.length) {
          const event = new CustomEvent(`drop-files-${context}`, {
            detail: { files },
          });
          document.dispatchEvent(event);
        }
      },
      canDrop() {
        return true;
      },
      hover(item) {
        if (item) {
          return true;
        }
        return false;
      },
      collect(monitor) {
        return {
          canDrop: monitor.canDrop(),
        };
      },
    }),
    []
  );
  const { t } = useTranslation();
  drop(dropRef);

  const dropPlaceholderStyle = {
    display: canDrop ? "block" : "none",
    pointerEvents: "all",
  };

  return (
    <div
      className={classnames("ang_drop_files_placeholder_react tw-p-3", className)}
      style={dropPlaceholderStyle}
      ref={dropRef}
    >
      <div className="ang_drop_files_inner_box tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full">
        <div className="ang_drop_files_message">{t("Drop here")}</div>
      </div>
    </div>
  );
};

AngDropFiles.propTypes = {
  onDrop: PropTypes.func,
  context: PropTypes.string,
  className: PropTypes.string,
  single: PropTypes.bool,
};

export default AngDropFiles;
